import React from 'react';
import PropTypes from 'prop-types';

import { ON_COLOR_SETTINGS } from 'constants/settings';

import {
  useClearNotificationEffect,
  useOverideCssVariableEffect,
} from '../shared/hooks';
import OnColorButtons from '../shared/OnColorButtons';
import StatusLabel from '../shared/StatusLabel';

import { getColorFromSetting } from '../utils';

const ARIA_BASE = 'company_settings_text_on_secondary_color';

const BUTTON_ARIA_LABELS = {
  [ON_COLOR_SETTINGS.AUTO]: t(
    'settings.tab.customization.text_on_secondary_color.aria.auto',
  ),
  [ON_COLOR_SETTINGS.DARK]: t(
    'settings.tab.customization.text_on_secondary_color.aria.dark',
  ),
  [ON_COLOR_SETTINGS.LIGHT]: t(
    'settings.tab.customization.text_on_secondary_color.aria.light',
  ),
};

const SettingsTextOnSecondaryColor = ({
  name,
  error,
  success,
  onChange,
  color,
  secondaryColor,
  clearSuccess,
}) => {
  const onColorChange = value =>
    onChange(name, value, { settings: { color_on_secondary: value } });

  const hexColor = getColorFromSetting(color, secondaryColor);
  useOverideCssVariableEffect('color-on-secondary', hexColor);

  useClearNotificationEffect(success, name, clearSuccess);

  return (
    <div className="controls mb-24">
      <div className="d-f mb-8">
        <p className="d-f ai-c jc-c mb-0 lh-24">
          {t('settings.tab.customization.text_on_secondary_color.title')}
        </p>
        <StatusLabel success={success} error={error} />
      </div>
      <div className="SettingsContent-radio d-f fw-w">
        <OnColorButtons
          ariaBase={ARIA_BASE}
          ariaLabels={BUTTON_ARIA_LABELS}
          buttonClassName="SettingsContent-radioButtonSecondary"
          onColorChange={onColorChange}
          color={color}
          complentaryColor={secondaryColor}
        />
      </div>
    </div>
  );
};

SettingsTextOnSecondaryColor.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  success: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  clearSuccess: PropTypes.func.isRequired,
};

export default props => <SettingsTextOnSecondaryColor {...props} />;
